module.exports = __webpack_public_path__ + "static/fireball-mtg_clb-ba1e9ffe91ccc443583006f0d3a1c758.jpg";